module.exports = {
  merchantName: "Wok-U-Like",
  merchantDomain: "https://wokulikechineseleixlip.com", // Need correct！ project will upload dist to targer domain file in Plesk.
  merchantMenuUrl: "/menu-wok-u-like-chinese-takeaway-leixlip", // target merchant's menu url in alleatapp.com
  // when you building files, fill this info, dont push these to github.
  pleskUsername: "root",
  pleskPs: "D03BQ3Hb",
};
